import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';

const useStyles = makeStyles({
  tooltipLabel: {
    fontSize: fonts.sizes.small,
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.25px',
    lineHeight: '20px',
    color: colors.white,
  },
  tooltipCenterContent: {
    textAlign: 'center',
    width: '100%',
  },
});

export default useStyles;
